/**
 * Backend API manzillari.
 *
 * - `VITE_API_BASE_URL` — to‘liq URL (masalan https://api.example.com) bo‘lsa,
 *   barcha so‘rovlar shu hostga ketadi (CORS backendda yoqilgan bo‘lishi kerak).
 * - Bo‘sh bo‘lsa — nisbiy yo‘llar ishlatiladi: `/api/v1/...`
 *   (Vite `server.proxy` yoki production nginx bir xil domen orqali backendga yo‘naltiradi).
 */

export function getApiBaseUrl() {
    const raw = import.meta.env.VITE_API_BASE_URL?.trim()?.replace(/\/+$/, '');
    return raw || '';
}

/**
 * @param {string} path - `/api/v1/...` ko‘rinishida
 * @returns {string} to‘liq yoki nisbiy URL
 */
export function apiUrl(path) {
    const base = getApiBaseUrl();
    const normalized = path.startsWith('/') ? path : `/${path}`;
    if (base) {
        return `${base}${normalized}`;
    }
    return normalized;
}

/**
 * Media/rasm URL (nisbiy yoki to‘liq)
 */
export function resolveMediaUrl(path) {
    if (path == null || path === '') return null;
    const s = String(path);
    if (s.startsWith('http://') || s.startsWith('https://')) return s;
    const base = getApiBaseUrl();
    if (base) {
        return `${base}${s.startsWith('/') ? '' : '/'}${s}`;
    }
    return s.startsWith('/') ? s : `/${s}`;
}
